import React from 'react';

import { type Product } from 'generated/graphql';

import OptionGroup from './OptionGroup';

import styles from './Details.module.scss';

interface Props {
  item?: Product | null;
  visible?: boolean;
}

const OptionGroups: React.FC<Props> = ({ item, visible }) => {
  if (!item) {
    return null;
  }

  const { options } = item;

  return (
    <ul className={`${styles.OptionGroups} ${visible ? styles.Visible : ''}`} data-testid="optionGroups-container">
      {options.map((option) => {
        return <OptionGroup optionGroup={option} key={option.posId} />;
      })}
    </ul>
  );
};

export default OptionGroups;
